// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_FecharInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /caixa/fechar/:id
 */
import { registerContract } from './validate'

export interface Caixa_FecharInput {
saldo_final_declarado: number
observacao?: string
}

registerContract('Caixa_FecharInput', {
  saldo_final_declarado: { type: 'number',  required: true },
  observacao:            { type: 'string',  required: false },
})
